import React from 'react';
import PropTypes from 'prop-types';

import { Span } from '@sopranodesign/pulse-components';

const GenerativeAiResultScoreScope = ({ content }) => {
  const percentage = content.value === '' ? '' : content.value.toLocaleString(undefined, {
    style: 'percent',
    minimumFractionDigits: 2,
  });
  return <Span>{percentage}</Span>;
};

GenerativeAiResultScoreScope.propTypes = {
  content: PropTypes.shape({
    value: PropTypes.number.isRequired
  }).isRequired
};

export default GenerativeAiResultScoreScope;
